@if(!viewToolbar && !paypal && !auth && !purchase){
<div
  (scroll)="onScrollToolbarBaner($event)"
  class="as-container-toolbar-download-app"
  [ngClass]="{ 'as-container-toolbar-download-app-none': !visibleBanner }"
>
  <div class="as-toolbar-download-app">
    <img
      class="as-imagen-app-icon-alsuper"
      src="assets/images/AppIcon_Alsuper_Square.png"
    />
    <div>
      <p class="as-title-toolbar-donwload">
        {{ 'GENERAL.titleToolbarDonwload' | translate }}
      </p>
      <a [href]="urlStore" target="_blank">
        <p class="as-donwload-app-toolbar">
          {{ 'GENERAL.donwloadAppToolbar' | translate }}
        </p>
      </a>
    </div>
  </div>
  <div (click)="closeToolbar()">
    <mat-icon
      svgIcon="ic-close-white"
      class="as-pointer as-close-white"
    ></mat-icon>
  </div>
</div>
} @if(!purchase && !auth && !paypal){
<mat-sidenav-container [hasBackdrop]="true">
  @if(!purchase && !auth && !paypal){
  <mat-sidenav-content class="as-home-main-content">
    <app-home-toolbar [sizeAdjustment]="viewToolbar" *ngIf="!auth || !paypal">
    </app-home-toolbar>
    <router-outlet></router-outlet>
    <app-newsletter *ngIf="!auth && home"></app-newsletter>
  </mat-sidenav-content>
  }
</mat-sidenav-container>
}
<div class="ic-share-container">
  @if(copy){
  <div class="ic-link-text">
    <p class="as-font as-font-white as-font-14">
      {{ 'GENERAL.copyLink' | translate }}
    </p>
  </div>
  }
</div>
@if(!auth && !purchase && !paypal){
<app-home-footer></app-home-footer>
} @if(purchase || auth || paypal){
<main>
  <router-outlet></router-outlet>
</main>
}
